/** True while scripts/prerender.js is snapshotting pages; skip analytics/tracking then. */
export const isPrerender = typeof navigator !== 'undefined' && navigator.userAgent.includes('KosmcPrerender')
